import React from "react";
import { Table } from 'react-bootstrap';





const OrderDetails = (props) => {
  

   console.log("OrderDetails",props);
 
  const { image, name, price,date } = props.or;




  return (



    <div className="container">
    <Table responsive="sm">

    
      <tr>
        <td>
          <img
            style={{ height: "50px", width: "50px", borderRadius: "30px" }}
            src={image}
            alt=""
          />
        </td>
        <td>{date}</td>
        <td>{name}</td>
        <td>${price}</td>
      </tr>
      </Table>
    </div>




  );
};

export default OrderDetails;
